export class AthenaUsageTier {
    name?: string;
    lowerLimit = 0;
    upperLimit = 0;

    deserialize(data: any) {
        this.name = data.name ?? '';
        this.lowerLimit = data.lower_limit ?? 0;
        this.upperLimit = data.upper_limit ?? 0;
        return this;
    }

    static Sort(p1: AthenaUsageTier, p2: AthenaUsageTier): number {
        // Limits can never overlap, so simply sorting by lower limit is ok
        return p1.lowerLimit - p2.lowerLimit;
    }
}
